export default "__VITE_ASSET__BEXrCj6u__"